import axios from "axios";
import apiClient from "./apiClient";

const AUTH_PATH = "/api/v3/auth";

// const handleRequest = async (method, path, data) => {
//   try {
//     const response = await apiClient[method](`${AUTH_PATH}${path}`, data);
//     return response.data;
//   } catch (error) {
//     console.error(`Auth ${method.toUpperCase()} request failed:`, error);
//     throw error?.response?.data || error;
//   }
// };

const handleRequest = async (method, path, data, config = {}) => {
  try {
    const url = `${AUTH_PATH}${path}`;

    const isQueryMethod = ["get", "delete"].includes(method);

    const response = isQueryMethod
      ? await apiClient[method](url, { ...config, params: data })
      : await apiClient[method](url, data, config);

    return response.data;
  } catch (error) {
    console.error(`Auth ${method.toUpperCase()} request failed:`, error);
    throw error?.response?.data || error;
  }
};

// RESET PASSWORD PAGE AUTHENTICATOR
export const validateResetPasswordLink = (accessToken) =>
  handleRequest("get", "/validateResetPasswordLink?token=" + accessToken);

// User login
export const loginApi = (credentials) =>
  handleRequest("post", "/login", credentials);

// User sign-up
export const signUp = (userData) => handleRequest("post", "/signup", userData);

// google user profile
export const getGoogleUserProfile = async (token) =>
  await axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

// MICROSOFT USER PROFILE
export const getMicrosoftUserProfile = async (accessToken) => {
  try {
    const response = await axios.get("https://graph.microsoft.com/v1.0/me", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Microsoft user profile:", error);
    throw error;
  }
};

// ***************************************AUTHENTICATORS STARTS HERE******************************************

export const commonSignUpApi = async (userData) => {
  return await handleRequest("post", "/commonSignup", userData);
};

export const commonLoginApi = async (credentials) => {
  return await handleRequest("post", "/commonLogin", credentials);
};

export const setUserTypeApi = async (userTypeData) => {
  return await handleRequest("post", "/selectUserType", userTypeData);
};
export const accessControlConsoleApi = async (accessControlData) => {
  return await handleRequest("post", "/accessConsole", accessControlData);
};
export const accessWebAppApi = async (accessWebAppData) => {
  return await handleRequest("post", "/accessWebApp", accessWebAppData);
};

export const forgotPasswordApi = async (emailData) => {
  return await handleRequest("post", "/sendResetPasswordLink", emailData);
};

export const resetPasswordFromEmailApi = async (resetData) => {
  return await handleRequest("post", "/resetPasswordFromEmail", resetData);
};

export const verifyEmailApi = async (token) => {
  return await handleRequest("get", "/verifyEmail", { token });
};
// ***************************************AUTHENTICATORS ENDS HERE******************************************

// Fetch industries list

const HOME_PATH = "/api/v3/home";
export const getIndustriesListApi = async () => {
  const response = await apiClient.get(`${HOME_PATH}/getAllIndustries`);
  return response.data;
};
